import FormNumberInput from 'components/new-ui/composed/formInput/FormNumberInput';

type Props = {
    index: number;
    isReadOnly: boolean;
};

const QuantityCell = ({ index, isReadOnly }: Props) => {
    return (
        <FormNumberInput name={`additionalCharges.${index}.quantity`} disabled={isReadOnly} step={1} min={1} max={99} />
    );
};

export default QuantityCell;
